import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {
  LayoutContainerAuthenticationComponent
} from "@iw-shared/layout/container-authentication/layout-container-authentication.component";
import {LayoutContainerLoggedInComponent} from "@iw-shared/layout/container-logged-in/layout-container-logged-in.component";
import {ContentLoadingComponent} from "@iw-shared/layout/content-loading/content-loading.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {RouterLink, RouterLinkActive} from "@angular/router";
import {ContextMenuModule} from "primeng/contextmenu";

@NgModule({
    declarations: [
        LayoutContainerAuthenticationComponent,
        ContentLoadingComponent,
        LayoutContainerLoggedInComponent,
    ],
  imports: [
    CommonModule,
    FaIconComponent,
    RouterLink,
    RouterLinkActive,
    ContextMenuModule
  ],
    exports: [
        LayoutContainerAuthenticationComponent,
        ContentLoadingComponent,
        LayoutContainerLoggedInComponent,
    ]
})
export class LayoutModule {
}
